import React, { useState } from "react";
import { BsTelephoneFill } from "react-icons/bs";
import { FaUser, FaEnvelope, FaTimes, FaPlus, FaMinus } from "react-icons/fa";

export const Trucker = ({ truckerInfo, accounts = [], onSave, onClose }) => {
  const [name, setName] = useState(truckerInfo?.name || "");
  const [phone, setPhone] = useState(truckerInfo?.phone || "");
  const [mainEmail, setMainEmail] = useState(
    truckerInfo?.trucker_emails?.[0]?.email || ""
  );
  const [ccEmails, setCcEmails] = useState(
    truckerInfo?.trucker_emails?.[0]?.cc_emails || []
  );
  const [selectedAccounts, setSelectedAccounts] = useState(
    truckerInfo?.accounts || accounts.map((a) => (typeof a === "object" ? a.account_no : a))
  );

  const [nameError, setNameError] = useState("");

  const handleAddCcEmail = () => {
    if (ccEmails.length < 10) {
      setCcEmails([...ccEmails, ""]);
    }
  };

  const handleCcEmailChange = (index, value) => {
    const updated = [...ccEmails];
    updated[index] = value;
    setCcEmails(updated);
  };

  const handleRemoveCcEmail = (index) => {
    setCcEmails(ccEmails.filter((_, i) => i !== index));
  };

  const handleSubmit = (e) => {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    if (!name.trim()) {
      setNameError("Name cannot be empty");
      return;
    }

    const updatedTrucker = {
      ...truckerInfo,
      name,
      phone,
      accounts: selectedAccounts,
      trucker_emails: [
        {
          email: mainEmail,
          cc_emails: ccEmails.filter((email) => email.trim() !== ""),
        },
      ],
    };

    onSave(updatedTrucker);
  };

  return (
    <div className="modal-backdrop">
      <div className="modal-content trucker-modal">
        <div className="modal-header">
          <h3>{truckerInfo?.name ? `Edit ${truckerInfo.name}` : "New Trucker"}</h3>
          <button type="button" className="close-btn" onClick={onClose}>
            <FaTimes />
          </button>
        </div>

        <div className="trucker-modal-form">
          <div className="form-group">
            <label>Name</label>
            <div className="input-with-icon">
              <FaUser className="input-icon" />
              <input
                type="text"
                value={name}
                onChange={(e) => {
                  setName(e.target.value);
                  if (e.target.value.trim()) setNameError("");
                }}
                placeholder="Trucker Name"
              />
            </div>
            {nameError && <p className="error-text">{nameError}</p>}
          </div>

          <div className="form-group">
            <label>Phone Number</label>
            <div className="input-with-icon">
              <BsTelephoneFill className="input-icon" />
              <input
                type="text"
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
                placeholder="Phone Number"
              />
            </div>
          </div>

          <div className="form-group">
            <label>Main Email Address</label>
            <div className="input-with-icon">
              <FaEnvelope className="input-icon" />
              <input
                type="email"
                value={mainEmail}
                onChange={(e) => setMainEmail(e.target.value)}
                placeholder="Main Email Address"
              />
            </div>
          </div>

          <div className="form-group">
            <label>CC Email Addresses</label>
            {ccEmails.map((email, idx) => (
              <div key={idx} className="cc-email-row">
                <div className="input-with-icon">
                  <FaEnvelope className="input-icon" />
                  <input
                    type="email"
                    value={email}
                    onChange={(e) => handleCcEmailChange(idx, e.target.value)}
                    placeholder="CC Email Address"
                  />
                </div>
                <button
                  type="button"
                  className="row-remove-btn"
                  onClick={() => handleRemoveCcEmail(idx)}
                >
                  <FaMinus />
                </button>
              </div>
            ))}

            {ccEmails.length < 10 && (
              <button
                type="button"
                className="add-cc-btn"
                onClick={handleAddCcEmail}
              >
                <FaPlus /> Add CC Email
              </button>
            )}
          </div>

          <div className="modal-actions">
            <button type="button" className="cancel-btn" onClick={onClose}>
              Cancel
            </button>
            <button type="button" className="save-btn" onClick={handleSubmit}>
              Save Trucker
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Trucker;
